export default __webpack_public_path__ + "static/media/Boots of Flowing Water.a996a006.jpg";